import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');


function AddArtist() {
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({ firstName: '', lastName: '' });
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();

    const token = sessionStorage.getItem('JWT_TOKEN');

    useEffect(() => {
        document.documentElement.className = "";
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!formData.firstName) newErrors.firstName = "First Name is required.";
        if (!formData.lastName) newErrors.lastName = "Last Name is required.";    
        return newErrors;
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addartist`, {
                    "firstName": formData.firstName,
                    "lastName": formData.lastName
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Artist added successfully!" });
                    setTimeout(() => redirectHistory('/artists'), 2500); // thoda delay deke redirect                     
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add artist. Please try again");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/artists" className='btn btn-primary'>Artists</Link></li>
                        <li>Add Artist</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add Artist
                            </p>
                        </header>
                        <div className="card-content">
                            <form onSubmit={handleAdd}>
                                {alert.message && (
                                    <AlertMessage
                                        type={alert.type}
                                        message={alert.message}
                                        onClose={() => setAlert({ type: "", message: "" })}
                                    />
                                )}

                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label" htmlFor="firstName">First Name <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" id="firstName" type="text" placeholder="First Name" value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} />
                                        </div>
                                        {errors.firstName && <p className="help" style={{ color: 'red' }}>{errors.firstName}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label" htmlFor="lastName">Last Name <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" id="lastName" type="text" placeholder="Last Name" value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} />
                                        </div>
                                        {errors.lastName && <p className="help" style={{ color: 'red' }}>{errors.lastName}</p>}
                                    </div>
                                </div>                        
                                <div className="flex justify-center items-center">
                                    <div className="field grouped">
                                        <div className="control">
                                            <button type="submit" className="button green">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddArtist;